module.exports = "<div #container style=\"width:100%; height: 75vh;\"></div>\n"